webpackJsonp([35783957827783],{

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(38);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(60);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(59);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(103);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(102);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FullscreenVideo = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fadeIn = (0, _styledComponents.keyframes)(['from{opacity:0;}to{opacity:1;}']);
	
	var Close = _styledComponents2.default.span.withConfig({
	  displayName: 'FullscreenVideo__Close'
	})(['backface-visibility:hidden;height:25px;position:absolute;right:0;top:0;transition:transform 0.2s;width:25px;&:before{background-color:white;content:\'\';height:2px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%) rotate(45deg);width:25px;}&:after{background-color:white;content:\'\';height:2px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%) rotate(135deg);width:25px;}&:hover{transform:rotate(45deg);}']);
	
	var Canvas = _styledComponents2.default.canvas.withConfig({
	  displayName: 'FullscreenVideo__Canvas'
	})(['backface-visibility:hidden;background:rgba(0,0,0,0.35);bottom:0;cursor:pointer;left:0;opacity:', ';right:0;position:absolute;transition:opacity 0.6s;width:100%;z-index:999;'], function (props) {
	  return props.showControls ? 1 : 0;
	});
	
	var Playbar = function (_React$Component) {
	  _inherits(Playbar, _React$Component);
	
	  function Playbar(props) {
	    _classCallCheck(this, Playbar);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { playing: false };
	    _this.clear = _this.clear.bind(_this);
	    _this.drawProgress = _this.drawProgress.bind(_this);
	    _this.seek = _this.seek.bind(_this);
	    _this.duration = null;
	    _this.video = _this.props.videoRef;
	    _this.video.addEventListener('loadeddata', function () {
	      _this.duration = _this.props.videoRef.duration;
	      window.requestAnimationFrame(_this.clear);
	    });
	    _this.lastPosition = null;
	    return _this;
	  }
	
	  Playbar.prototype.componentDidMount = function componentDidMount() {
	    this.setState({ playing: true });
	    this.duration = this.props.videoRef.duration;
	    this.clear();
	    window.requestAnimationFrame(this.drawProgress, true);
	  };
	
	  Playbar.prototype.seek = function seek(e) {
	    e.stopPropagation();
	    var rect = this.canvas.getBoundingClientRect();
	    var position = (e.clientX - rect.left) / this.canvas.width;
	    this.lastPosition = position;
	    this.props.videoRef.currentTime = this.duration * position;
	    this.clear();
	    this.drawProgress(true);
	  };
	
	  Playbar.prototype.clear = function clear() {
	    try {
	      this.ctx = this.canvas.getContext('2d');
	      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
	    } catch (error) {
	      return;
	    }
	  };
	
	  Playbar.prototype.drawProgress = function drawProgress(redraw) {
	    try {
	      var progress = this.props.videoRef.currentTime / this.duration;
	      var position = Math.floor(progress * this.canvas.width);
	
	      //return when no progression has taken place since last update
	      if (position === this.lastPosition) {
	        window.requestAnimationFrame(this.drawProgress);
	        return;
	      }
	
	      //video has restarted. clear canvas
	      if (position < this.lastPosition) {
	        this.clear();
	        this.ctx = this.canvas.getContext('2d');
	        this.ctx.fillStyle = 'White';
	        this.ctx.fillRect(0, 0, 1, this.canvas.height);
	        this.lastPosition = position;
	        window.requestAnimationFrame(this.drawProgress);
	        return;
	      }
	
	      this.ctx = this.canvas.getContext('2d');
	      this.ctx.fillStyle = 'White';
	      if (redraw) this.ctx.fillRect(0, 0, position, this.canvas.height);else this.ctx.fillRect(this.lastPosition, 0, position - this.lastPosition, this.canvas.height);
	      this.lastPosition = position;
	      window.requestAnimationFrame(this.drawProgress);
	    } catch (error) {
	      return;
	    }
	  };
	
	  Playbar.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(Canvas, {
	      showControls: this.props.showControls,
	      onClick: this.seek,
	      width: this.props.width,
	      height: 12,
	      innerRef: function innerRef(e) {
	        return _this2.canvas = e;
	      }
	    });
	  };
	
	  return Playbar;
	}(_react2.default.Component);
	
	var Video = _styledComponents2.default.video.withConfig({
	  displayName: 'FullscreenVideo__Video'
	})(['backface-visibility:hidden;height:100%;left:0;object-fit:cover;position:absolute;top:0;width:100%;']);
	
	var AspectRatio = _styledComponents2.default.div.withConfig({
	  displayName: 'FullscreenVideo__AspectRatio'
	})(['height:0;padding-top:56.25%;']);
	
	var VideoWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'FullscreenVideo__VideoWrapper'
	})(['animation-delay:0.4s;animation-duration:0.2s;animation-name:', ';animation-fill-mode:forwards;background-color:black;left:50%;max-width:60rem;opacity:0;overflow:hidden;position:fixed;top:50%;transform:translate(-50%,-50%) translateZ(999px) !important;width:100vw;z-index:999;'], fadeIn);
	
	var FullscreenVideo = exports.FullscreenVideo = function (_React$Component2) {
	  _inherits(FullscreenVideo, _React$Component2);
	
	  function FullscreenVideo(props) {
	    _classCallCheck(this, FullscreenVideo);
	
	    var _this3 = _possibleConstructorReturn(this, _React$Component2.call(this, props));
	
	    _this3.state = { width: null, showControls: true };
	    _this3.updateWidth = _this3.updateWidth.bind(_this3);
	    _this3.showControls = _this3.showControls.bind(_this3);
	    return _this3;
	  }
	
	  FullscreenVideo.prototype.showControls = function showControls() {
	    var _this4 = this;
	
	    this.setState({ showControls: true });
	    window.clearTimeout(this.showTimeout);
	    this.showTimeout = window.setTimeout(function () {
	      _this4.setState({ showControls: false });
	    }, 2000);
	  };
	
	  FullscreenVideo.prototype.componentDidMount = function componentDidMount() {
	    var _this5 = this;
	
	    this.videoElement.play();
	    this.updateWidth();
	    this.showTimeout = window.setTimeout(function () {
	      _this5.setState({ showControls: false });
	    }, 2000);
	  };
	
	  FullscreenVideo.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.clearTimeout(this.showTimeout);
	  };
	
	  FullscreenVideo.prototype.updateWidth = function updateWidth() {
	    this.setState({ width: this.videoElement.offsetWidth });
	  };
	
	  FullscreenVideo.prototype.render = function render() {
	    var _this6 = this;
	
	    return _react2.default.createElement(
	      VideoWrapper,
	      { innerRef: function innerRef(e) {
	          return _this6.DOMElement = e;
	        } },
	      _react2.default.createElement(
	        AspectRatio,
	        null,
	        _react2.default.createElement(
	          Video,
	          { onMouseEnter: this.showControls, innerRef: function innerRef(e) {
	              return _this6.videoElement = e;
	            }, loop: true },
	          _react2.default.createElement('source', { src: this.props.element.video, type: 'video/mp4' })
	        )
	      ),
	      this.videoElement && _react2.default.createElement(Playbar, { showControls: this.state.showControls, width: this.state.width, videoRef: this.videoElement })
	    );
	  };
	
	  return FullscreenVideo;
	}(_react2.default.Component);

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  flex-wrap: wrap;\n    margin: ', ' auto;\n    width: auto;\n  '], ['\n  flex-wrap: wrap;\n    margin: ', ' auto;\n    width: auto;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    margin-right: ', ';\n    font-size: ', ';\n    margin-left: 0 !important;\n  '], ['\n    margin-right: ', ';\n    font-size: ', ';\n    margin-left: 0 !important;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Styling = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CategoriesMenu = _styledComponents2.default.div.withConfig({
	  displayName: 'GalleryFilter__CategoriesMenu'
	})(['-webkit-overflow-scrolling:touch;display:inline-flex;flex-wrap:nowrap;margin:', ' auto;overflow:scroll;text-transform:capitalize;width:100%;', ';'], _Styling.spacing[4], _Styling.mediaQueries.medium(_templateObject, _Styling.spacing[5]));
	
	var Category = _styledComponents2.default.span.withConfig({
	  displayName: 'GalleryFilter__Category'
	})(['background-color:', ';border:2px solid ', ';color:', ';cursor:pointer;flex:0 1 auto;font-family:', ';font-size:', ';margin-bottom:', ';padding:0.5rem 1rem;transition:color 0.2s,background-color 0.2s,border-color 0.2s,z-index 0,0.2s;white-space:nowrap;z-index:', ';&:not(:first-child){margin-left:-2px;}', ';&:hover{color:white;background-color:', ';}'], function (props) {
	  return props.category === props.currentCategory ? _Styling.colors.black : 'white';
	}, function (props) {
	  return props.category === props.currentCategory ? _Styling.colors.black : 'DARKGREY';
	}, function (props) {
	  return props.category === props.currentCategory ? 'white' : 'DARKGREY';
	}, _Styling.fonts.sans, _Styling.fontSizes[1], _Styling.spacing[3], function (props) {
	  return props.category === props.currentCategory ? 0 : 'initial';
	}, _Styling.mediaQueries.medium(_templateObject2, _Styling.spacing[3], _Styling.fontSizes[2]), function (props) {
	  return props.category === props.currentCategory ? _Styling.colors.black : 'DARKGREY';
	});
	
	var GalleryFilter = function (_React$Component) {
	  _inherits(GalleryFilter, _React$Component);
	
	  function GalleryFilter(props) {
	    _classCallCheck(this, GalleryFilter);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  GalleryFilter.prototype.handleClick = function handleClick(hasValue) {
	    this.props.handleClick(hasValue);
	  };
	
	  GalleryFilter.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        CategoriesMenu,
	        null,
	        ['all'].concat(this.props.categories.sort()).map(function (category) {
	          return _react2.default.createElement(
	            Category,
	            {
	              currentCategory: _this2.props.currentCategory,
	              category: category,
	              key: category,
	              onClick: function onClick() {
	                return _this2.handleClick(category);
	              }
	            },
	            category
	          );
	        })
	      )
	    );
	  };
	
	  return GalleryFilter;
	}(_react2.default.Component);
	
	exports.default = GalleryFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Grid = undefined;
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Styling = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Grid = exports.Grid = _styledComponents2.default.div.withConfig({
	  displayName: 'Grid'
	})(['display:flex;flex-wrap:wrap;font-family:', ';transform-style:preserve-3d;*{transform-style:preserve-3d;}&:after{background-color:black;content:\'\';height:400vh;left:-50vw;opacity:', ';pointer-events:', ';position:fixed;top:-100vh;transition:opacity 0.2s;width:400vw;z-index:99;transform:translateZ(1px);}'], _Styling.fonts.sans, function (props) {
	  return props.dim ? 0.75 : 0;
	}, function (props) {
	  return props.dim ? 'initial' : 'none';
	});

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.GridElement = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n      font-size: ', ';\n  '], ['\n      font-size: ', ';\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    padding: ', ';\n    transform: ', ';\n    width: ', ';\n  '], ['\n    padding: ', ';\n    transform: ', ';\n    width: ', ';\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    padding-top: \'56.25%\';\n  '], ['\n    padding-top: \'56.25%\';\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    flex-basis: ', ';\n    '], ['\n    flex-basis: ', ';\n    ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    flex-basis: ', ';\n  '], ['\n    flex-basis: ', ';\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(129);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Styling = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function convertRemToPixels(rem) {
	  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
	}
	
	var GridLabel = _styledComponents2.default.span.withConfig({
	  displayName: 'GridElement__GridLabel'
	})(['display:inline-block;float:', ';font-size:', ';', ';'], function (props) {
	  return props.right ? 'right' : 'initial';
	}, _Styling.fontSizes[1], _Styling.mediaQueries.medium(_templateObject, _Styling.fontSizes[2]));
	
	var GridTitle = _styledComponents2.default.h2.withConfig({
	  displayName: 'GridElement__GridTitle'
	})(['font-size:', ';', ';'], _Styling.fontSizes[3], _Styling.mediaQueries.medium(_templateObject, _Styling.fontSizes[3]));
	
	var GridDescription = _styledComponents2.default.p.withConfig({
	  displayName: 'GridElement__GridDescription'
	})(['opacity:', ';transition:opacity 0.3s;'], function (props) {
	  return props.show || props.active ? 1 : 0;
	});
	
	var fadeIn = (0, _styledComponents.keyframes)(['from{opacity:0;}to{opacity:1;}']);
	
	var Inner = _styledComponents2.default.div.withConfig({
	  displayName: 'GridElement__Inner'
	})(['animation-duration:0.5s;animation-name:', ';animation-fill-mode:forwards;backface-visibility:hidden;background-color:rgba(0,0,0,0.1);color:white;height:100%;left:0;padding:calc(2vw + ', ');position:absolute;transform:', ';transform-origin:left bottom;top:0;width:100%;', ';', ';'], function (props) {
	  return props.animationName;
	}, _Styling.spacing[2], function (props) {
	  return props.active ? 'translateY(-100%)' : 'initial';
	}, _Styling.mediaQueries.medium(_templateObject2, _Styling.spacing[4], function (props) {
	  return props.active ? 'translateY(-100%) scale(.75)' : 'scale(1)';
	}, function (props) {
	  return props.active ? 'calc(100% + 100% / 3)' : '100%';
	}), _Styling.mediaQueries.large(_templateObject2, _Styling.spacing[4], function (props) {
	  return props.active ? 'translateY(-100%) scale(.5)' : 'scale(1)';
	}, function (props) {
	  return props.active ? 'calc(200%)' : '100%';
	}));
	
	var StyledVideo = _styledComponents2.default.video.withConfig({
	  displayName: 'GridElement__StyledVideo'
	})(['backface-visibility:hidden;height:calc(100% + 2px);left:-1px;object-fit:cover;opacity:', ';position:absolute;top:-1px;transition:opacity 0.2s;width:calc(100% + 2px);z-index:1;'], function (props) {
	  return props.hide ? 0 : 1;
	});
	
	var Poster = (0, _styledComponents2.default)(_gatsbyImage2.default).withConfig({
	  displayName: 'GridElement__Poster'
	})(['height:100%;left:0;object-fit:cover;position:absolute;top:0;width:100%;']);
	
	var PosterWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'GridElement__PosterWrapper'
	})(['height:100%;left:0;opacity:', ';position:absolute;top:0;width:100%;transition:opacity 0.2s;'], function (props) {
	  return props.hide ? 0 : 1;
	});
	
	var Video = function (_React$Component) {
	  _inherits(Video, _React$Component);
	
	  function Video(props) {
	    _classCallCheck(this, Video);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.pause = function () {
	      _this.video.pause();
	    };
	
	    _this.play = function () {
	      _this.video.play();
	    };
	
	    _this.state = { loading: true };
	    _this.pause = _this.pause.bind(_this);
	    _this.play = _this.play.bind(_this);
	    _this.sourceLoaded = false;
	    _this.hasSource = null;
	    return _this;
	  }
	
	  Video.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.hover) {
	      if (!this.sourceLoaded) {
	        this.sourceLoaded = true;
	        this.refs.sourceRef.src = this.props.video;
	        this.video.load();
	        this.video.addEventListener('canplay', this.play);
	        this.video.addEventListener('canplay', this.props.didLoad);
	        return;
	      }
	      this.play();
	    } else if (!nextProps.hover) {
	      this.video.removeEventListener('canplay', this.play);
	      this.pause();
	    }
	  };
	
	  Video.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      StyledVideo,
	      { show: this.props.show, loop: true, muted: true, innerRef: function innerRef(e) {
	          return _this2.video = e;
	        } },
	      _react2.default.createElement('source', { ref: 'sourceRef', src: '', type: 'video/mp4' })
	    );
	  };
	
	  return Video;
	}(_react2.default.Component);
	
	var VideoWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'GridElement__VideoWrapper'
	})(['height:0;left:0;overflow:hidden;padding-top:56.25%;position:absolute;top:0;width:100%;']);
	
	var ContentWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'GridElement__ContentWrapper'
	})(['height:0;opacity:', ';padding-top:56.25%;transition:', ';transform:', ';transition-timing-function:cubic-bezier(0.86,0,0.07,1);', ';&:after{background-color:white;content:\'\';height:100%;left:0;opacity:', ';position:absolute;top:0;transition:opacity 0.4s;transform:translateZ(0);width:100%;}&:hover{transition:transform 0.2s 0.05s;transform:translateZ(200px) scale(1.05);:after{opacity:0 !important;}}'], function (props) {
	  return props.active ? 0 : 1;
	}, function (props) {
	  return props.active ? 'opacity 0s .5s, transform .4s !important' : 'transform .18s';
	}, function (props) {
	  return props.active ? 'translateX(calc(-' + props.rect.left + 'px + 50vw - 50%)) translateY(calc(-1 * ' + props.rect.top + 'px + 50vh - 50%)) translateZ(200px) scale(' + (window.innerWidth <= convertRemToPixels(60) ? window.innerWidth / props.rect.width : convertRemToPixels(60) / props.rect.width) + ') !important' : 'translateZ(0px) scale(1);';
	}, _Styling.mediaQueries.medium(_templateObject3), function (props) {
	  return props.fade ? 0.4 : 0;
	});
	
	var UnstyledGridElement = function (_React$Component2) {
	  _inherits(UnstyledGridElement, _React$Component2);
	
	  function UnstyledGridElement(props) {
	    _classCallCheck(this, UnstyledGridElement);
	
	    var _this3 = _possibleConstructorReturn(this, _React$Component2.call(this, props));
	
	    _this3.state = {
	      hover: false,
	      boundingClientRect: null,
	      animationName: fadeIn,
	      didLoad: false
	    };
	    _this3.setHover = _this3.setHover.bind(_this3);
	    _this3.updatePosition = _this3.updatePosition.bind(_this3);
	    return _this3;
	  }
	
	  UnstyledGridElement.prototype.restartAnimation = function restartAnimation() {
	    var _this4 = this;
	
	    this.setState({ animationName: 'none' });
	    setTimeout(function () {
	      _this4.setState({ animationName: fadeIn });
	    }, 0);
	  };
	
	  UnstyledGridElement.prototype.componentDidMount = function componentDidMount() {
	    this.updatePosition();
	  };
	
	  UnstyledGridElement.prototype.updatePosition = function updatePosition() {
	    var rect = this.elementRect.getBoundingClientRect();
	    this.setState({ boundingClientRect: rect });
	  };
	
	  UnstyledGridElement.prototype.setHover = function setHover(value) {
	    this.setState({ hover: value });
	    this.props.toggleHover(value);
	  };
	
	  UnstyledGridElement.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.active !== this.props.active) {
	      this.updatePosition();
	      this.restartAnimation();
	    }
	  };
	
	  UnstyledGridElement.prototype.render = function render() {
	    var _this5 = this;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: this.props.className,
	        data: this.props.data,
	        onMouseEnter: function onMouseEnter() {
	          return _this5.setHover(true);
	        },
	        onMouseLeave: function onMouseLeave() {
	          return _this5.setHover(false);
	        },
	        onClick: function onClick() {
	          return _this5.props.toggleActive(_this5.props.data);
	        },
	        ref: function ref(e) {
	          return _this5.elementRect = e;
	        }
	      },
	      _react2.default.createElement(
	        ContentWrapper,
	        {
	          data: this.props.data,
	          fade: this.props.fade,
	          active: this.props.active,
	          rect: this.state.boundingClientRect
	        },
	        _react2.default.createElement(
	          VideoWrapper,
	          { rect: this.state.boundingClientRect },
	          _react2.default.createElement(Video, {
	            didLoad: function didLoad() {
	              _this5.setState({ didLoad: true });
	            },
	            hide: !this.state.didLoad,
	            active: this.props.active,
	            hover: this.state.hover,
	            video: this.props.data.videoShort
	          }),
	          _react2.default.createElement(
	            PosterWrapper,
	            null,
	            _react2.default.createElement(Poster, {
	              sizes: this.props.images.filter(function (image) {
	                return image.node.name === _this5.props.data.image.match(/(\/media\/)(.*)(\.jpg|.png|.gif|.jpeg|.tiff|.webp)/)[2];
	              })[0].node.childImageSharp.sizes
	            })
	          )
	        ),
	        !this.props.active && _react2.default.createElement(
	          Inner,
	          { active: this.props.active, animationName: this.state.posterDidLoad ? this.state.animationName : '' },
	          _react2.default.createElement(
	            GridLabel,
	            null,
	            ' ',
	            this.props.data.year,
	            '\xA0 '
	          ),
	          _react2.default.createElement(
	            GridLabel,
	            { right: !this.props.active },
	            ' ',
	            this.props.data.client,
	            ' '
	          ),
	          _react2.default.createElement(
	            GridTitle,
	            null,
	            ' ',
	            this.props.data.title,
	            ' '
	          ),
	          _react2.default.createElement(
	            GridDescription,
	            { active: this.props.active, show: this.state.hover },
	            ' ',
	            this.props.data.descriptionShort,
	            ' '
	          ),
	          this.props.active && _react2.default.createElement(Close, null)
	        )
	      )
	    );
	  };
	
	  return UnstyledGridElement;
	}(_react2.default.Component);
	
	var GridElement = exports.GridElement = (0, _styledComponents2.default)(UnstyledGridElement).withConfig({
	  displayName: 'GridElement'
	})(['animation-duration:0.25s;animation-name:', ';flex:0 0 100%;order:', ';position:relative;transition:', ';', ';', ';'], fadeIn, function (props) {
	  return props.data.priority ? props.data.priority : 1;
	}, function (props) {
	  return props.active ? 'none' : 'all 0.2s';
	}, _Styling.mediaQueries.medium(_templateObject4, function (props) {
	  return props.data.fullWidth ? '100%' : '50%';
	}), _Styling.mediaQueries.large(_templateObject5, function (props) {
	  return props.data.fullWidth ? 'calc(100% / 1.5)' : 'calc(100%/3)';
	}));

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Spinner = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rotate = (0, _styledComponents.keyframes)(['from{transform:translate(-50%,0) rotate(0deg);}to{transform:translate(-50%,0) rotate(360deg);}']);
	
	var fadeIn = (0, _styledComponents.keyframes)(['from{opacity:0;}to{opacity:1;}']);
	
	var Spinner = exports.Spinner = _styledComponents2.default.div.withConfig({
	  displayName: 'Spinner'
	})(['flex:1;position:relative;&::after{animation:', ' 0.25s ease-in 0.5s forwards,', ' 0.75s linear infinite;border-radius:50%;border:3px solid GhostWhite;border-left:3px solid Gray;content:\'\';opacity:0;height:calc(1em + 3.5vw);left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:calc(1em + 3.5vw);}'], fadeIn, rotate);

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(49);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _GalleryFilter = __webpack_require__(275);
	
	var _GalleryFilter2 = _interopRequireDefault(_GalleryFilter);
	
	var _Styling = __webpack_require__(18);
	
	var _Grid = __webpack_require__(276);
	
	var _GridElement = __webpack_require__(277);
	
	var _FullscreenVideo = __webpack_require__(274);
	
	var _Spinner = __webpack_require__(279);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnstyledIndexPage = function (_React$Component) {
	  _inherits(UnstyledIndexPage, _React$Component);
	
	  function UnstyledIndexPage(props) {
	    _classCallCheck(this, UnstyledIndexPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.setHover = function (value) {
	      _this.setState({ gridElementHover: value });
	    };
	
	    _this.setCategory = function (category) {
	      _this.setState({ currentCategory: category });
	    };
	
	    _this.toggleActive = function (element) {
	      _this.setState({ gridElementActive: !_this.state.gridElementActive, activeElement: element });
	    };
	
	    var categories = [];
	    _this.props.data.workPosts.edges.forEach(function (post) {
	      if (!post.node.frontmatter.hidden && post.node.frontmatter.category) post.node.frontmatter.category.split(/\s*,\s*/).forEach(function (e) {
	        if (categories.indexOf(e) === -1) categories.push(e);
	      });
	    });
	
	    _this.state = {
	      gridElementHover: false,
	      categories: categories,
	      currentCategory: 'all',
	      gridElementActive: false,
	      activeElement: null
	    };
	
	    _this.setHover = _this.setHover.bind(_this);
	    _this.setCategory = _this.setCategory.bind(_this);
	    _this.toggleActive = _this.toggleActive.bind(_this);
	    return _this;
	  }
	
	  UnstyledIndexPage.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    if (!this.props.transition) return false;else return true;
	  };
	
	  UnstyledIndexPage.prototype.render = function render() {
	    var _this2 = this;
	
	    if (!this.props.transition || this.props.transition && this.props.transition.status === 'exited') return _react2.default.createElement(_Spinner.Spinner, null);else {
	      var indexPage = this.props.data.indexPage.edges[0].node;
	      var posts = this.props.data.workPosts.edges;
	      var images = this.props.data.images.edges;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: this.props.transition && this.props.transition.style,
	          className: this.props.className,
	          onClick: function onClick() {
	            if (_this2.state.gridElementActive) _this2.toggleActive();
	          }
	        },
	        _react2.default.createElement(
	          _Styling.Heading,
	          null,
	          indexPage.frontmatter.title
	        ),
	        _react2.default.createElement(
	          _Styling.Paragraph,
	          { onIndex: true },
	          indexPage.frontmatter.subtitle
	        ),
	        _react2.default.createElement(_GalleryFilter2.default, {
	          handleClick: this.setCategory,
	          currentCategory: this.state.currentCategory,
	          categories: this.state.categories
	        }),
	        _react2.default.createElement(
	          _Grid.Grid,
	          { dim: this.state.gridElementActive },
	          posts.filter(function (post) {
	            return !post.node.frontmatter.hidden && (post.node.frontmatter.category && post.node.frontmatter.category.split(/\s*,\s*/).indexOf(_this2.state.currentCategory) !== -1 || _this2.state.currentCategory === 'all');
	          }).map(function (_ref) {
	            var post = _ref.node;
	
	            return _react2.default.createElement(_GridElement.GridElement, {
	              active: _this2.state.gridElementActive && _this2.state.activeElement.videoShort === post.frontmatter.videoShort,
	              fade: _this2.state.gridElementHover,
	              images: images,
	              toggleActive: _this2.toggleActive,
	              toggleHover: _this2.setHover,
	              key: post.frontmatter.videoShort,
	              data: post.frontmatter
	            });
	          })
	        ),
	        this.state.gridElementActive && _react2.default.createElement(_FullscreenVideo.FullscreenVideo, { element: this.state.activeElement })
	      );
	    }
	  };
	
	  return UnstyledIndexPage;
	}(_react2.default.Component);
	
	var IndexPage = (0, _styledComponents2.default)(UnstyledIndexPage).withConfig({
	  displayName: 'pages__IndexPage'
	})(['flex:1;']);
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-331aaf50139021027a2a.js